exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Array2DRenderer_array_2d__GFND0 {\n  flex-shrink: 0;\n  display: table;\n  border-collapse: collapse; }\n  .Array2DRenderer_array_2d__GFND0 .Array2DRenderer_row__2AhI2 {\n    display: table-row;\n    height: 28px; }\n    .Array2DRenderer_array_2d__GFND0 .Array2DRenderer_row__2AhI2 .Array2DRenderer_col___7iHS {\n      display: table-cell;\n      text-align: center;\n      min-width: 28px;\n      background-color: #393939;\n      border: 1px solid #505050;\n      padding: 0 4px; }\n      .Array2DRenderer_array_2d__GFND0 .Array2DRenderer_row__2AhI2 .Array2DRenderer_col___7iHS .Array2DRenderer_value__2hqED {\n        font-size: 12px; }\n      .Array2DRenderer_array_2d__GFND0 .Array2DRenderer_row__2AhI2 .Array2DRenderer_col___7iHS.Array2DRenderer_selected__36Jpq {\n        background-color: #2962ff; }\n      .Array2DRenderer_array_2d__GFND0 .Array2DRenderer_row__2AhI2 .Array2DRenderer_col___7iHS.Array2DRenderer_patched__RzGnA {\n        background-color: #c51162; }\n      .Array2DRenderer_array_2d__GFND0 .Array2DRenderer_row__2AhI2 .Array2DRenderer_col___7iHS.Array2DRenderer_index__c6iPJ {\n        background: none;\n        border: none;\n        color: #505050; }\n", ""]);

// Exports
exports.locals = {
	"themeDark": "#242424",
	"themeNormal": "#393939",
	"themeLight": "#505050",
	"colorFont": "#bbbbbb",
	"colorShadow": "rgba(0, 0, 0, 0.2)",
	"colorOverlay": "rgba(255, 255, 255, 0.1)",
	"colorAlert": "#f3bd58",
	"colorSelected": "#2962ff",
	"colorPatched": "#c51162",
	"colorHighlight": "#29d",
	"colorActive": "#00e676",
	"lineHeight": "32px",
	"fontSizeNormal": "12px",
	"fontSizeLarge": "14px",
	"array_2d": "Array2DRenderer_array_2d__GFND0",
	"row": "Array2DRenderer_row__2AhI2",
	"col": "Array2DRenderer_col___7iHS",
	"value": "Array2DRenderer_value__2hqED",
	"selected": "Array2DRenderer_selected__36Jpq",
	"patched": "Array2DRenderer_patched__RzGnA",
	"index": "Array2DRenderer_index__c6iPJ"
};